import _ from 'underscore';
import Promise from 'bluebird';
import { CurrencyUtils } from '@bingads-webui-clientcenter/entity-utils';
import type { Currency, DomainDataRecord, FindAllRepository } from './types';

let sortedCurrencies: Currency[] | undefined;

/**
 * @type {currency}
 * @param {string} currency.DisplayName Currency localized name
 * @param {string} currency.Code Currency code
 * @param {number} currency.ControlledCurrencyCountryId Controlled currency country id
 * @param {number} currency.Id Currency id
 */

/**
 * Get currencies from MT domainData by calling controller: API/DomainData/Currency
 * @param {object} jsDataCcRest jsData object
 * @returns {promise<currency[]>} The formatted currencies
 */
export const findCurrencies = (jsDataCcRest: { DomainDataCurrency: FindAllRepository<DomainDataRecord<Currency>> }) => {
  if (_.isUndefined(sortedCurrencies)) {
    return jsDataCcRest.DomainDataCurrency.findAll().then((currencies) => {
      sortedCurrencies = CurrencyUtils.sortCurrencies(_.pluck(currencies, 'value'));
      return sortedCurrencies;
    });
  }
  return Promise.resolve(sortedCurrencies);
};
